// ===== Utility Functions =====

export const formatIndicatorValue = (
  value: number | null | undefined,
  unit?: string,
  options?: { raw?: boolean }
): string => {
  if (value === null || value === undefined) return '-'
  const suffix = unit || ''
  const attachedUnits = ['%', '배', '편', ':1']

  // raw: 반올림 없이 소수점 3자리에서 절삭(버림) 후 천 단위 구분자만 적용해 표시
  if (options?.raw) {
    const truncated = Math.trunc(value * 1000) / 1000
    const formatted = new Intl.NumberFormat('ko-KR', { maximumFractionDigits: 3 }).format(truncated)
    if (attachedUnits.includes(suffix)) return `${formatted}${suffix}`
    return `${formatted}${suffix ? ` ${suffix}` : ''}`
  }

  if (attachedUnits.includes(suffix)) {
    return `${value.toFixed(1)}${suffix}`
  }
  return `${new Intl.NumberFormat('ko-KR').format(Math.round(value))}${suffix ? ` ${suffix}` : ''}`
}

/** Parse string value to number, handling commas */
export const parseIndicatorValue = (raw: string | undefined | null): number | null => {
  if (!raw || raw.trim() === '') return null
  const cleaned = raw.replace(/,/g, '').trim()
  const num = parseFloat(cleaned)
  return isNaN(num) ? null : num
}

/** Department indicator flag labels */
export const DEPT_INDICATOR_LABELS: Record<string, { label: string; unit: string }> = {
  v1: { label: '장학금', unit: '만원' },
  v2: { label: '등록금', unit: '만원' },
  v3: { label: '취업률', unit: '' },
  v4: { label: '교원1인당학생', unit: '명' },
  v5: { label: '재적학생수', unit: '명' },
  v7: { label: '충원율', unit: '%' },
  v8: { label: '1인당교육비', unit: '원' },
}

/** Columns to display in department data table */
export const DEPT_DISPLAY_FLAGS = ['v1', 'v2', 'v3', 'v4', 'v5', 'v7', 'v8'] as const
